import React from 'react';

export const CapSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
  >
    <path
      d="M12.8214 10.4334V6.79996L12.9251 6.73959C13.1452 6.61184 13.2764 6.3839 13.2764 6.12971C13.2764 5.87552 13.1452 5.64715 12.9251 5.5194L7.60644 2.42977C7.15887 2.16902 6.60194 2.16946 6.15438 2.42977L0.83525 5.51984C0.615625 5.64759 0.484375 5.87552 0.484375 6.12971C0.484375 6.3839 0.615625 6.61184 0.83525 6.74002L2.44788 7.67715V9.85546C2.44788 10.3612 2.72 10.8315 3.1575 11.084L5.37738 12.3636C5.84069 12.6305 6.36044 12.7644 6.88019 12.7644C7.39994 12.7644 7.91925 12.631 8.383 12.3636L10.6024 11.084C11.0404 10.832 11.3125 10.3612 11.3125 9.85546V7.67671L12.0339 7.25759V10.4334C11.8489 10.5594 11.7273 10.7716 11.7273 11.0126C11.7273 11.3994 12.0409 11.7131 12.4277 11.7131C12.8144 11.7131 13.1281 11.3994 13.1281 11.0126C13.1281 10.772 13.0065 10.5598 12.8214 10.4334ZM10.5254 9.85502H10.525C10.525 10.0799 10.4047 10.289 10.2096 10.401L7.99013 11.6807C7.30587 12.0749 6.45494 12.0749 5.77112 11.6807L3.55125 10.401C3.35656 10.289 3.23581 10.0799 3.23581 9.85502V8.13434L6.15438 9.83009C6.37838 9.96002 6.6295 10.0252 6.88062 10.0252C7.13175 10.0252 7.38287 9.96046 7.60687 9.83009L10.5254 8.13434V9.85502ZM7.21094 9.14934C7.00706 9.2679 6.75375 9.2679 6.54987 9.14934L1.35281 6.12971L6.54944 3.11009C6.75331 2.99152 7.00663 2.99152 7.2105 3.11009L12.4076 6.12927L7.21094 9.14934Z"
      fill="#A5A5A5"
    />
  </svg>
);

export default CapSvg;
